import React from "react";
import "./BusinessSolutions.css";

const services = [
  {
    iconClass: "fas fa-shield-alt",
    iconColor: "#ef4444", // Cybersecurity - Red
    title: "Cybersecurity Services",
    description: "Protect your organization with advanced threat detection, risk assessments, and compliance aligned with FAR/DFARS, NIST, and CMMC frameworks."
  },
  {
    iconClass: "fas fa-headset",
    iconColor: "#22c55e", // IT Consultation - Green
    title: "IT Consultation & Managed Services",
    description: "Strategic technology advisory, system optimization, and 24/7 managed services to keep your operations running efficiently and securely."
  },
  {
    iconClass: "fas fa-robot",
    iconColor: "#8b5cf6", // AI & Data - Purple
    title: "AI & Data Intelligence Solutions",
    description: "Leverage AI, Machine Learning, and Data Analytics to enhance decision-making, automate processes, and gain actionable insights."
  },
  {
    iconClass: "fas fa-cloud",
    iconColor: "#0ea5e9", // Cloud Integration - Sky Blue
    title: "Cloud & System Integration",
    description: "Deploy hybrid and multi-cloud infrastructures with seamless system integration, ensuring reliability, scalability, and business continuity."
  },
  {
    iconClass: "fas fa-code",
    iconColor: "#6366f1", // Development - Indigo
    title: "Website & Application Development",
    description: "Custom web, mobile, and enterprise applications built for performance, scalability, and excellent user experience."
  },
  {
    iconClass: "fas fa-box-open",
    iconColor: "#f97316", // Hardware / Reselling - Orange
    title: "Hardware & Software Reselling",
    description: "Reliable supply of enterprise-grade hardware, software licenses, and cloud solutions from top vendors."
  },
  {
    iconClass: "fas fa-bolt",
    iconColor: "#facc15", // Fast Delivery - Yellow
    title: "Fast Delivery",
    description: "Rapid deployment and delivery with well-planned project execution."
  },
  {
    iconClass: "fas fa-life-ring",
    iconColor: "#22c55e", // 24/7 Support - Green
    title: "24/7 Support",
    description: "Round-the-clock support for all your technical and IT needs, ensuring minimal downtime."
  }
];

const BusinessSolutions = () => {
  return (
    <div className="services-page">
      <h1 className="services-main-heading">Our Services</h1>
      <p className="services-intro">
        At inframart solutions, we provide a comprehensive range of IT and digital services designed to optimize operations, enhance security, and drive innovation. From federal-compliant cybersecurity solutions to AI-driven insights and cloud integration, our offerings empower businesses to perform smarter, faster, and more securely.
      </p>

      <div className="services-grid">
        {services.map((service, idx) => (
          <div className="service-card" key={idx}>
            <div className="service-icon">
              <i className={service.iconClass} style={{ color: service.iconColor }}></i>
            </div>
            <h3 className="service-title">{service.title}</h3>
            <p className="service-text">{service.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BusinessSolutions;
